module.exports = __webpack_public_path__ + "static/media/2.7a10e67b.JPG";